import type { SingularBlock } from '~/utils/ninetailed/types';

export const mapBaselineContentfulEntry = (entry: SingularBlock) => {
  return {
    id: entry.sys.id,
    ...entry
  };
};
